import { GET_MEMBERSHIPS, GET_MEMBERSHIPS_SUCCESS, GET_MEMBERSHIPS_ERROR, GET_MEMBERSHIPS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetMemberships = (state = initialState, action) => {
  switch (action.type) {
    case GET_MEMBERSHIPS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_MEMBERSHIPS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_MEMBERSHIPS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_MEMBERSHIPS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetMemberships;
